<template>
  <el-select v-model="selectedLanguage" @change="switchLanguage" :placeholder="currentLanguageLabel">
    <el-option v-for="item in supportedLanguages" :key="item.value" :label="item.label" :value="item.value">
    </el-option>
  </el-select>
</template>
  
<script>

export default {
  data() {
    return {
      selectedLanguage: '', // Holds the selected language value
      supportedLanguages: [ // An array of supported languages
        { label: 'English', value: 'en' },
        { label: '简体中文', value: 'zh' },
      ],
      currentLanguageFlag: null,
    };
  },
  methods: {
    switchLanguage() {
      // Update the current language in vue-i18n based on the selected value
      this.$i18n.locale = this.selectedLanguage;
      localStorage.setItem('selectedLanguage', this.selectedLanguage);
      // console.log('LanguageSelect/this.$i18n.locale: ' + this.$i18n.locale)
      if ('zh' == this.$i18n.locale) {
        this.currentLanguageFlag = 0
      } else if ('en' == this.$i18n.locale) {
        this.currentLanguageFlag = 1
      }
      this.$emit('language-change', this.currentLanguageFlag)
    },
  },
  computed: {
    currentLanguageLabel() {
      // Retrieve the current language from vue-i18n
      const currentLanguage = this.$i18n.locale;

      // Find the label for the current language
      const currentLanguageOption = this.supportedLanguages.find(option => option.value === currentLanguage);

      // Return the label or fallback to a default value
      return currentLanguageOption ? currentLanguageOption.label : 'Language';
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-input__inner {
  margin-top: 20px;
  width: 100px;
  background: transparent !important;
  color: #ccc;
  border: none;
}

.input.el-input {
  width: 100px;
  background: transparent !important;
  color: black;
  border: none;
}

/deep/ .el-input__suffix {
  margin-top: 10px;
  color: #ffffff;
}
</style>